import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import { ApiService } from './services/api.service';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import i18n from './i18n';
import { RECAPTCHA_SITE_KEY } from './config/consts';

ApiService.init(process.env.VUE_APP_ROOT_API);
Vue.config.productionTip = false;

Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_SITE_KEY });

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
